import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import 'Angular/polyfills';

export function bootstrapAppModule(appModule: any): void {
    if (process.env.YC_CODE_ENV === 'development') {
        platformBrowserDynamic().bootstrapModule(appModule);
    } else {
        enableProdMode();
        platformBrowser().bootstrapModule(appModule);
    }
}
